import { CloseButton } from '@components/utility/buttons';
import { EventFormikType } from '@event/types/event';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    Paper,
    Typography,
} from '@mui/material';
import { useFormikContext } from 'formik';

const AllowTemporaryRegistrationDialog = (props: DialogProps) => {
    const { setFieldValue } = useFormikContext<EventFormikType>();

    const handleClose = (_e: {}, _reason?: string, answer?: boolean) => {
        setFieldValue('allow_temporary_registration', answer ?? false);
        props.onClose?.({}, 'escapeKeyDown');
    };

    return (
        <Dialog {...props} disableEscapeKeyDown classes={{ paper: 'dialog-paper' }} onClose={handleClose}>
            <CloseButton onClick={handleClose} />
            <DialogTitle align="center">
                <Typography
                    fontFamily="museo-sans"
                    className="mb-3 px-28"
                    fontSize={32}
                    fontWeight={500}
                    letterSpacing={-0.8}
                    lineHeight="110%"
                >
                    Are you sure you want to allow temporary registration?
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography fontSize={16} className="px-10 mx-auto text-center" lineHeight="150%">
                    By enabling temporary registration, attendees who are already registered for prerequisite events
                    (that award the required badges) will be able to reserve a spot in this event before completing
                    those prerequisites
                </Typography>
                <Paper className="mt-4 p-6">
                    <Typography fontFamily="museo-sans" fontWeight={600} lineHeight="32px" className="mb-3">
                        Important considerations:
                    </Typography>
                    <ul className="list-disc m-auto pl-8 rounded bg-neutral-100 p-[10px]">
                        <Typography component="li" fontFamily="museo-sans" fontWeight={300} className="mb-3">
                            Attendees will hold spots with temporary registrations that may not be confirmed if they
                            don't attend their prerequisite events
                        </Typography>
                        <Typography component="li" fontFamily="museo-sans" fontWeight={300}>
                            This may affect your ability to accurately predict final attendance numbers
                        </Typography>
                    </ul>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button
                    fullWidth
                    color="secondary-alt"
                    className="rounded-full black-border"
                    startIcon={<CloseIcon />}
                    onClick={handleClose}
                >
                    <Typography fontSize={15} fontWeight={500} letterSpacing={0.46} color="black.main">
                        Cancel
                    </Typography>
                </Button>
                <Button
                    fullWidth
                    className="rounded-full black-border"
                    color="primary"
                    startIcon={<CheckCircleOutlinedIcon />}
                    onClick={() => handleClose({}, '', true)}
                >
                    <Typography fontSize={15} fontWeight={500} letterSpacing={0.46}>
                        Confirm
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { AllowTemporaryRegistrationDialog };
